import {
  CDN_ASSET_HOST_PRODUCTION,
  CDN_ASSET_HOST_STAGING,
} from '../../constants/clientAssets';
import { isProduction, isStaging } from '../../lib/errorReporting';

import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { getClientId } from '../../selectors/client';
import { useEffect } from 'react';

const CSSSwitcher = ({ clientId }) => {
  if (!clientId) {
    return null;
  }

  useEffect(() => {
    const getUrl = () => {
      if (isStaging()) {
        return `${CDN_ASSET_HOST_STAGING}/clients/${clientId}/cav2/styles.css`;
      }

      if (isProduction()) {
        return `${CDN_ASSET_HOST_PRODUCTION}/clients/${clientId}/cav2/styles.css`;
      }

      return `/assets/${clientId}/cav2/styles.css`;
    };

    const applyClientTheme = async () => {
      const cssUrl = await getUrl();

      if (cssUrl) {
        // eslint-disable-next-line prefer-destructuring
        const head = document.getElementsByTagName('head')[0];
        const link = document.createElement('link');

        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = cssUrl;

        head.appendChild(link);
      }
    };

    applyClientTheme();
  }, []);
  return null;
};

CSSSwitcher.propTypes = {
  clientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

CSSSwitcher.defaultProps = {
  clientId: '44',
};

const mapStateToProps = state => ({
  clientId: getClientId(state),
});

export default compose(connect(mapStateToProps, null))(CSSSwitcher);
